import Loading from './../misc/Loading';
import React from 'react';
import queryString from 'query-string';
import cookie from 'js-cookie';
import makesModel from '../../../../model/makes';
import giftcardModel from './../../../../model/giftcard';
import {NavLink as Link} from 'react-router-dom';
import withRouter from '/src/components/misc/withRouter';
import PublishStatusTableRow from '../table/PublishStatusTableRow';
import PublishStatusDot from '../../../misc/PublishStatusDot';

const giftcardMakeFilterCookieName = 'mgGiftcardMakeFilter';

class GiftcardsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modified: false,
      working: true,
      error: null,
      filter: null,
      hideArchived: true,
      giftcards: []
    };

    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  componentDidMount() {
    let filter = this.state.filter;
    const query = queryString.parse(this.props.location.search);

    if (query && query.filter) {
      filter = query.filter;
    } else {
      const cookiefilter = cookie.get(giftcardMakeFilterCookieName);

      if (cookiefilter !== 'null') { // null is string in this case
        filter = cookiefilter;
      }
    }

    document.title = 'Admin - Gavekort';

    makesModel.all().then((makes) => {
      this.setState({
        makes: makes,
        filter: filter
      }, () => {
        this.fetchGiftcards();
      });
    });
  }

  fetchGiftcards() {
    const params = {};
    if (this.state.filter) {
      params.makeId = this.state.filter;
    }

    return giftcardModel.getAll(1, params).then((giftcards) => {
      this.setState({
        giftcards: giftcards,
        working: false
      });
    });
  }

  handleFilterChange(makeId) {
    // Reset paging, so we always start on first page after filtering
    cookie.set(giftcardMakeFilterCookieName, makeId, {path: '/'});
    this.setState({
      working: true,
      filter: makeId
    }, () => {
      this.props.history.replace({
        pathname: '/giftcards',
        search: queryString.stringify({
          filter: makeId
        })
      });

      this.fetchGiftcards();
    });
  }

  toggleShowArchived() {
    this.setState({
      hideArchived: !this.state.hideArchived
    });
  }

  printFilterButton() {
    const boxFilterBtnDisabled = this.state.giftcards.length === 0 && this.state.filter === null;

    return (
      <div className="btn-group" role="group">
        <div className="dropdown">
          <button
            type="button"
            data-toggle="dropdown"
            className={`btn btn-default dropdown-toggle${boxFilterBtnDisabled ? ' disabled' : ''}`}
            disabled={this.state.working}
          >
            Merke: <strong>{this.selectedMakeName || 'Alle'}</strong> <span className="caret"></span>
          </button>
          <ul className="dropdown-menu" >
            <li className={this.state.filter === null ? 'active' : ''}>
              <a href="#" onClick={(e) => {
                e.preventDefault();
                this.handleFilterChange(null);
              }}>
                Alle
              </a>
            </li>
            <li role="separator" className="divider"></li>
            {this.state.makes.map((make, i) => {
              return (
                <li key={`make-${i}`} className={this.state.filter === make.id ? 'active' : ''}>
                  <a href="#" onClick={(e) => {
                    e.preventDefault();
                    this.handleFilterChange(make.id);
                  }}>
                    {make.name}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }

  render() {
    if (!this.state.working) {
      this.selectedMakeName = null;
      if (this.state.filter) {
        this.state.makes.forEach((make) => {
          if (make.id === this.state.filter) {
            this.selectedMakeName = make.name;
          }
        });
      }

      const now = new Date();

      return (
        <section>
          <div className="mf-model">
            <ol className="breadcrumb mf-margin-top-20">
              <li><Link to="/">Forsiden</Link></li>
              <li className="active">Gavekort</li>
            </ol>
            <div className="page-header">
              <div className="pull-right">
                <button onClick={() => {
                  this.toggleShowArchived();
                }} className="btn btn-info" disabled={this.state.working}>
                  {this.state.hideArchived ? 'Vis arkiverte' : 'Skjul arkiverte'}
                </button>
                &nbsp;
                {this.printFilterButton()}
                &nbsp;
                &nbsp;
                <Link
                  to='/giftcards/new'
                  className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}
                >
                  <i className="fa fa-plus" aria-hidden="true"></i> Nytt gavekort
                </Link>
              </div>
              <h1>Gavekort</h1>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th title="Publiseringsstatus"></th>
                    <th>Tittel</th>
                    <th>Opprettet</th>
                    <th>Status</th>
                    <th className="hidden-xs hidden-sm">Beskrivelse</th>
                    <th className="hidden-xs">Merke</th>
                  </tr>
                </thead>

                <tbody>
                  {this.state.giftcards.map((giftcard) => {
                    if (this.state.hideArchived && giftcard.archived) {
                      return;
                    }

                    return (
                      <PublishStatusTableRow entry={giftcard} key={`giftcard-${giftcard.id}`}>
                        <td className="text-center"><PublishStatusDot entry={giftcard} /></td>
                        <td><Link to={`/giftcards/${giftcard.id}`}>{giftcard.title}</Link></td>
                        <td>{giftcard.created.toLocaleString('nb')}</td>
                        <td>{now >= giftcard.expires ? 'Utløpt' : 'Aktivt'}</td>
                        <td className="hidden-xs hidden-sm">
                          {giftcard.description &&
                            <span>{giftcard.description.substring(0, 100)}{giftcard.description.length > 100 && <span>...</span>}</span>
                          }
                        </td>
                        <td>
                          {giftcard.makes &&
                            giftcard.makes.map((gcm) => gcm.name).join(', ')
                          }
                          {!giftcard.makes &&
                            'Alle'
                          }
                        </td>
                      </PublishStatusTableRow>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

        </section>
      );
    }

    return (
      <Loading title="Gavekort" text="Laster gavekort" />
    );
  }
}

GiftcardsList.defaultProps = {
};

export default withRouter(GiftcardsList);
